/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Paging metadata
 * @export
 * @interface ListOperations200ResponsePaging
 */
export interface ListOperations200ResponsePaging {
    /**
     * 全体件数
     * @type {number}
     * @memberof ListOperations200ResponsePaging
     */
    totalCount?: number;
    /**
     * 現在のページ番号
     * @type {number}
     * @memberof ListOperations200ResponsePaging
     */
    page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof ListOperations200ResponsePaging
     */
    count?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof ListOperations200ResponsePaging
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ListOperations200ResponsePaging interface.
 */
export function instanceOfListOperations200ResponsePaging(value: object): value is ListOperations200ResponsePaging {
    return true;
}

export function ListOperations200ResponsePagingFromJSON(json: any): ListOperations200ResponsePaging {
    return ListOperations200ResponsePagingFromJSONTyped(json, false);
}

export function ListOperations200ResponsePagingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOperations200ResponsePaging {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['total_count'] == null ? undefined : json['total_count'],
        'page': json['page'] == null ? undefined : json['page'],
        'count': json['count'] == null ? undefined : json['count'],
        'totalPages': json['total_pages'] == null ? undefined : json['total_pages'],
    };
}

export function ListOperations200ResponsePagingToJSON(json: any): ListOperations200ResponsePaging {
    return ListOperations200ResponsePagingToJSONTyped(json, false);
}

export function ListOperations200ResponsePagingToJSONTyped(value?: ListOperations200ResponsePaging | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_count': value['totalCount'],
        'page': value['page'],
        'count': value['count'],
        'total_pages': value['totalPages'],
    };
}

